import { FieldNode } from 'graphql'

function getAggregationsNode(fieldNodes, name: string): FieldNode | undefined {
  return fieldNodes.find(({ name: { value } }) => value === name)
}

export function getRequestedFields(fieldNodes, name: string): string[] {
  const aggregationsNode = getAggregationsNode(fieldNodes, name)
  return !!aggregationsNode && !!aggregationsNode.selectionSet
    ? aggregationsNode.selectionSet.selections
        .filter((selection) => {
          const fieldSelection = selection as FieldNode
          return !!fieldSelection.name
        })
        .map((selection) => {
          const fieldSelection = selection as FieldNode
          return fieldSelection.name.value
        })
    : []
}
